var m = require('mithril');

var WIDTH_OPTIONS = [
  { value: 1, label: 'Single', segments: 1 },
  { value: 2, label: 'Double', segments: 2 },
  { value: 3, label: 'Three Quarter', segments: 3 },
  { value: 4, label: 'Full', segments: 4 }
];

function selectedValue(value) {
  return typeof value === 'function' ? value() : value;
}

function renderIcon(activeSegments) {
  var cells = [];
  [0, 1, 2, 3].forEach(function (index) {
    cells.push(m('rect', {
      x: 18 + (index * 16),
      y: 14,
      width: 12,
      height: 20,
      rx: 1,
      fill: index < activeSegments ? 'var(--width-selector-fill)' : 'var(--width-selector-empty)'
    }));
  });

  return m('svg.width-option-icon', {
    viewBox: '0 0 96 48',
    role: 'img',
    focusable: 'false',
    'aria-hidden': 'true'
  }, [
    m('rect', {
      x: 12,
      y: 10,
      width: 72,
      height: 28,
      rx: 2,
      fill: 'none',
      stroke: 'var(--width-selector-soft)',
      'stroke-width': 3
    })
  ].concat(cells));
}

function renderWidthOption(option, config) {
  var selected = String(selectedValue(config.selectedWidth)) === String(option.value);
  var disabled = !!config.disabled;
  var className = 'width-option-button' + (selected ? ' is-selected' : '');

  return m('button', {
    key: option.value,
    type: 'button',
    class: className,
    title: option.label,
    'aria-label': option.label + ' width',
    'aria-pressed': selected ? 'true' : 'false',
    disabled: disabled ? true : undefined,
    onclick: function () {
      if (disabled) return;
      config.onselect(option.value);
    }
  }, renderIcon(option.segments));
}

function renderWidthSelector(config) {
  config = config || {};

  return m('div.width-selector', WIDTH_OPTIONS.map(function (option) {
    return renderWidthOption(option, config);
  }));
}

module.exports = renderWidthSelector;
